import MobileCheck from "../utils/MobileCheck";

export default class NavLang {
    static init() {
        const trigger = document.querySelector(".nav-lang");

        if (trigger) {
            if (MobileCheck.isMobileOrTablet()) {
                document.addEventListener('click', (e) => {
                    const withinBoundaries = e.composedPath().includes(trigger);

                    if (withinBoundaries) {
                        trigger.classList.add('nav-lang-opened');
                    } else {
                        trigger.classList.remove('nav-lang-opened');
                    }
                });
            } else {
                trigger.addEventListener('mouseenter', (e) => {
                    trigger.classList.add('nav-lang-opened');
                });

                trigger.addEventListener('mouseleave', (e) => {
                    trigger.classList.remove('nav-lang-opened');
                });
            }
        }
    }
}